<template>
  <div class="upload-wrapper mt-10">
    <div class="avatar-section mb-15">
      <el-avatar
      class="d-flex flex-justify-center flex-align-items-center avatar"
      icon="el-icon-picture"
      :src="(prop.meta && prop.meta.imgUrl) ? `${prop.meta.imgUrl}?v=${this.moment().valueOf()}` : ''"
      :key="key"
      :size="120"></el-avatar>
    </div>
    <div v-if="isProfilePhotoRequired">
      <h5 style="margin: 0"><i class="el-icon-info"></i> {{photoRequiredNote}}</h5>
    </div>
    <div class="d-flex justify-content-center w-100">
      <vue-upload-component
      ref="upload"
      :drop=true
      v-model="files"
      :extensions="extensions"
      :accept="accept"
      :post-action="uploadURL"
      :headers="uploadHeaders"
      :data="entityData"
      :multiple=true
      @input-file="inputFile"
      @input-filter="inputFilter"
      class="el-button el-button--primary hidden">
      Upload
      </vue-upload-component>
      <el-button class="el-button el-button--primary upload-button" @click="uploadImage">Upload</el-button>
      <el-button icon="el-icon-delete" class="delete-button" @click="removeImage" v-if="prop.meta && prop.meta.imgUrl"></el-button>
    </div>
  </div>
</template>

<script>
import { errormsg, uploadURL } from '@/utils/constants';
import _ from 'lodash';

export default {
  name: 'UploadItem',
  props: {
    prop: Object,
    type: String,
    label: String,
    isProfilePhotoRequired: Boolean,
    photoRequiredNote: String
  },
  data() {
    return {
      uploadURL,
      files: [],
      key: 0,
      accept: 'image/png,image/jpg,image/jpeg,image/heic',
      extensions: 'jpg,jpeg,png',
    };
  },
  computed: {
    uploadHeaders() {
      return this.$store.getters['user/uploadHeaders'];
    },
    entityData() {
      return { _id: this.currentProp._id, type: this.type };
    },
    currentProp() {
      return this.$store.getters['cart/getCurrentMember'];
    }
  },
  methods: {
    uploadImage() {
      this.$store.commit('cart/setCurrentMember', this.prop);
      const element = document.querySelector('input[type="file"]');
      element.click();
    },
    inputFile(newFile, oldFile) {
      if (newFile && oldFile && !newFile.active && oldFile.active) {
        if (newFile.response.status === 'success') {
          const imgUrl = newFile.response.fullsize;
          this.prop = _.cloneDeep(this.currentProp);
          if (!this.prop.meta) {
            this.$set(this.prop, 'meta', {});
          }
          this.prop.meta.imgUrl = `${imgUrl}?v=${this.moment().valueOf()}`;
          this.$emit('imgChange', this.prop);
          this.$message.success('Successful');
          this.$store.commit('loading', false);
          this.key++;
        } else {
          this.$store.commit('loading', false);
          this.$message.error('Error uploading file');
        }
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      if (!/\.(png|jpg|jpeg)$/i.test(newFile.name)) {
        this.$message.error(errormsg.image_format);
        return prevent();
      }
      // 5mb limit
      if (newFile.size > 1024 * 1024 * 5) {
        this.$message.error(errormsg.file_size);
        return prevent();
      }
      this.$refs.upload.active = true;
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      return true;
    },
    removeImage() {
      this.$confirm('Are you sure you want to remove this image?', 'Warning')
        .then(() => {
          const { _id } = this.prop;
          this.$http
            .post('/assemble/api/v1/portal/logos/unset', { _id, type: this.type })
            .then(() => {
              this.$store.commit('loading', false);
              this.$message.success('Successful');
              delete this.prop.meta.imgUrl;
              this.$emit('imgChange', this.prop);
              this.key++;
            })
            .catch(() => {
              this.$store.commit('loading', false);
              this.$message.error('Error uploading file');
            });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.upload-wrapper {
  display: flex;
  gap: 1rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

 .avatar-section {
    overflow: hidden;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    // margin-bottom: 1.5rem;
    .avatar {
    //   background-color: transparent !important;
      font-size: 5.5rem;
      display: flex;
      justify-content: center;
      align-items: center;
      color: $primary !important;
    }
  }

  .upload-button {
    display: flex;
    justify-content: center;
    width: 7.5rem;
  }

  .hidden {

    display: none;
  }

  .delete-button {
    width: 7.5rem;
  }

::v-deep .copy .el-input-group__append {
  background-color: $highlight !important;
  border-color: $highlight !important;
  color: white;
}
</style>
